export const multiplyBy100 = (value?: number) => {
  if (value === undefined) {
    return undefined
  }
  return value * 100
}

export function isValidNumber<T extends number>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined && !isNaN(value) && isFinite(value)
}

export const isEven = (num: number) => num % 2 === 0

export const getMedian = (nums: number[]) => {
  if (nums.length === 0) {
    throw new Error('Array cannot be empty')
  }
  const sortedList = [...nums].sort((a, b) => a - b)
  const length = sortedList.length
  const mid = Math.floor(length / 2)
  if (isEven(length)) {
    return (sortedList[mid - 1] + sortedList[mid]) / 2
  }
  return sortedList[mid]
}

// This calculation is to get relative value from two absolute numbers
export const getRelativeValue = ({
  previousValue,
  currentValue,
}: {
  previousValue?: number | null
  currentValue?: number | null
}): number | undefined => {
  return currentValue != null && previousValue
    ? ((currentValue - previousValue) / previousValue) * 100
    : undefined
}

export const safelyFloor = (value?: number | null) => (value != null ? Math.floor(value) : null)
export const safelyRound = (value?: number | null) => (value != null ? Math.round(value) : null)
